import {
  TABLE_FIRST_CELL_WIDTH,
  TABLE_ROW_HEADER_DOUBLE_LINE_NO_LOGO,
  TABLE_WIDTH,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";

export class PDFPortfolioCompositionTableConfigs {
  static readonly MaxProductsDisplay = 5;

  static readonly FirstCellWidth = TABLE_FIRST_CELL_WIDTH;
  static readonly FollowingCellWidth =
    (TABLE_WIDTH - this.FirstCellWidth) / this.MaxProductsDisplay;

  static readonly TableHeaderHeight = TABLE_ROW_HEADER_DOUBLE_LINE_NO_LOGO + 5;
  static readonly TableFooterHeight = 20;
  static readonly TableTitleHeight = 20;
  static readonly SectionGapHeight = 30;
  static readonly HiddenProductsNoteHeight = 25;
  static readonly NoDataNoteHeight = 60;

  static readonly DefaultRowHeight = 16;
  static readonly RowHeightLinesMultiplier = 7.75;

  static readonly DefaultFontSize = 7;
  static readonly RowNameFontSize = 7;

  static readonly DefaultMaxCharsPerLine = 37;
  static readonly SubTotalMaxCharsPerLine = 39;

  static readonly FixedDecimalPlaces = 2;
}
